/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { dispatch } from '../../commentsAndCorrespondence/store/Actions';
import QuarterlyMarketingDataHeaders from './components/QuarterlyMarketingDataHeaders';
import { dispatchErrorMessage } from './store/action';

const QuarterlyMarketingData = ({}) => {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const errorMessages = useSelector(
    (state) => state?.sharedState?.QuarterlyMarketingDataReducer?.errorMessages
  );

  const setErrorMessages = (data) => {
    dispatch(dispatchErrorMessage(data));
  };

  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo === '/quarterlyMarketingData' &&
          errorMessages?.length > 0
        ) {
          item.isFormError = true;
        } else {
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessages]);

  return (
    <div className='tabs-container tBillPanel custom-check'>
      {loading && <Spinner load={loading} />}
      <CustomSeparator
        parent1='System'
        parent2='Technical Window'
        parent3='Quarterly Marketing Data'
      />

      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}

      <QuarterlyMarketingDataHeaders
        setErrorMessages={setErrorMessages}
        setSuccessMessages={setSuccessMessages}
        setLoading={setLoading}
      />
    </div>
  );
};
export default QuarterlyMarketingData;
